
import useBookingCalendar from "@/composables/useBookingCalendar";
import { defineComponent } from "vue";
import QuickformForm from "./QuickformForm.vue";

export default defineComponent({
	components: { QuickformForm },
	props: {
		isExternal: {
			type: Boolean,
			required: false
		}
	},
	setup() {
		useBookingCalendar(true);

		const toggleVideo = () => {
			const lightBox = document.querySelector("#booking-guide");
			const video = document.querySelector(
				"#booking-guide-video"
			) as HTMLMediaElement;

			if (lightBox && video) {
				lightBox.classList.remove("d-none");
				video.play();
			}
		};

		return { toggleVideo };
	},
});
